module.exports = __webpack_public_path__ + "img/cup.0865610e.svg";